<template>
  <div class="calendar-page">
    <el-card shadow="never" style="margin-bottom: 16px">
      <div class="cal-header">
        <el-button size="small" @click="prevMonth">◀ 上月</el-button>
        <span class="cal-title">{{ currentMonth }} 数据日历</span>
        <el-button size="small" @click="nextMonth">下月 ▶</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="loadData" style="margin-left: 12px">🔄 刷新</el-button>
        <span class="cal-hint">点击日期查看当天明细</span>
      </div>
    </el-card>

    <el-card shadow="never" style="margin-bottom: 16px">
      <el-calendar v-model="currentDate">
        <template #date-cell="{ data }">
          <div class="cal-cell" :class="{ 'has-data': dayData(data.day), 'is-today': data.day === today }" @click="selectDay(data.day)">
            <div class="cal-day">{{ Number(data.day.split('-')[2]) }}</div>
            <template v-if="dayData(data.day)">
              <div class="cal-total">{{ dayData(data.day).total }} 条</div>
              <div class="cal-a" v-if="dayData(data.day).a">🔴 A:{{ dayData(data.day).a }}</div>
              <div class="cal-b" v-if="dayData(data.day).b">🟡 B:{{ dayData(data.day).b }}</div>
              <div class="cal-dm" v-if="dayData(data.day).dm">💬 私信:{{ dayData(data.day).dm }}</div>
            </template>
          </div>
        </template>
      </el-calendar>
    </el-card>

    <!-- 当日明细 -->
    <el-card shadow="never">
      <template #header>
        <div class="detail-header">
          <span>📋 {{ selectedDay || '点击日期查看' }} 明细</span>
          <el-tag v-if="selectedDay && dayData(selectedDay)" type="info" size="small">
            共 {{ dayData(selectedDay).total }} 条 · A={{ dayData(selectedDay).a }} B={{ dayData(selectedDay).b }} C={{ dayData(selectedDay).c }} · 已处理 {{ dayData(selectedDay).processed }}
          </el-tag>
        </div>
      </template>
      <el-table :data="dayComments" v-loading="dayLoading" stripe size="small">
        <el-table-column label="等级" width="80" align="center">
          <template #default="{ row }">
            <el-tag :type="levelType(row.level)" size="small">{{ row.level }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="来源博主" width="140">
          <template #default="{ row }">
            <el-link v-if="row.blogger_url" type="primary" :href="row.blogger_url" target="_blank">{{ row.blogger_name }}</el-link>
            <span v-else>{{ row.blogger_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户" width="130">
          <template #default="{ row }">
            <el-link v-if="row.profile_url" type="primary" :href="row.profile_url" target="_blank">{{ row.username }}</el-link>
            <span v-else>{{ row.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="评论内容" min-width="240" show-overflow-tooltip>
          <template #default="{ row }">{{ row.content }}</template>
        </el-table-column>
        <el-table-column label="采集时间" width="130">
          <template #default="{ row }">{{ row.scraped_at }}</template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template #default="{ row }">
            <el-tag :type="statusType(row.status)" size="small">{{ row.status_label }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="selectedDay && !dayComments.length" class="empty-hint">该日期暂无数据</div>
    </el-card>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'DataCalendar',
  data() {
    const now = new Date()
    return {
      currentDate: now,
      today: now.toISOString().slice(0, 10),
      currentMonth: now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0'),
      days: {},
      selectedDay: '',
      loading: false,
      dayLoading: false,
      dayComments: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    levelType(lv) {
      return { A: 'danger', B: 'warning', C: 'info' }[lv] || 'info'
    },
    statusType(st) {
      return { new: 'info', traced: 'success', followed: 'success', dm_sent: 'danger', dm_blocked: 'warning', skip: 'info' }[st] || 'info'
    },
    dayData(day) {
      return this.days[day]
    },
    async loadData() {
      this.loading = true
      try {
        const d = await api.get('/intent/calendar', { params: { month: this.currentMonth } })
        this.days = d.days || {}
        this.today = d.today || this.today
        // 默认选中今天（若当天有数据）
        if (this.days[this.today]) this.selectDay(this.today)
      } catch (e) {
        this.$message.error('加载日历失败: ' + e.message)
      } finally {
        this.loading = false
      }
    },
    prevMonth() {
      const [y, m] = this.currentMonth.split('-').map(Number)
      const d = new Date(y, m - 2, 1)
      this.currentMonth = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0')
      this.currentDate = d
      this.loadData()
    },
    nextMonth() {
      const [y, m] = this.currentMonth.split('-').map(Number)
      const d = new Date(y, m, 1)
      this.currentMonth = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0')
      this.currentDate = d
      this.loadData()
    },
    async selectDay(day) {
      this.selectedDay = day
      this.dayLoading = true
      try {
        const d = await api.get('/intent/intent-comments', { params: { date: day } })
        this.dayComments = d.comments || []
      } catch (e) {
        this.$message.error('加载明细失败: ' + e.message)
      } finally {
        this.dayLoading = false
      }
    }
  }
}
</script>

<style scoped>
.cal-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.cal-title {
  font-size: 17px;
  font-weight: 700;
}
.cal-hint {
  font-size: 13px;
  color: #999;
  margin-left: auto;
}
.cal-cell {
  min-height: 68px;
  padding: 2px 6px;
  cursor: pointer;
  border-radius: 6px;
}
.cal-cell.has-data {
  background: rgba(34,197,94,.14);
}
.cal-cell.is-today {
  outline: 2px solid #409eff;
  outline-offset: -2px;
}
.cal-day {
  font-size: 13px;
  font-weight: 600;
}
.cal-total {
  font-size: 12px;
  color: #409eff;
  font-weight: 600;
}
.cal-a {
  font-size: 11px;
  color: #f56c6c;
}
.cal-b {
  font-size: 11px;
  color: #e6a23c;
}
.cal-dm {
  font-size: 11px;
  color: #67c23a;
}
.detail-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.empty-hint {
  text-align: center;
  color: #bbb;
  padding: 24px 0;
}
</style>
